export { BitbucketBackend } from './bitbucket';
export { GitGatewayBackend } from './git-gateway';
export { GitHubBackend } from './github';
export { GitLabBackend } from './gitlab';
export { GiteaBackend } from './gitea';
export { ProxyBackend } from './proxy';
export { TestBackend } from './test';
